var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-history-entry__field-content"},_vm._l((_vm.allItems),function(item){return _c('div',{key:item.id,staticClass:"row-history-entry__diff",class:{
      'row-history-entry__diff--removed': _vm.removedItems.includes(item),
      'row-history-entry__diff--added': _vm.addedItems.includes(item),
    }},[_vm._v("\n    "+_vm._s(item.visible_name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }